import { api } from "../API";

export default {
  init() {
    $(".agent-login-page form.login-form").on("submit", function(e) {
      e.preventDefault();
      $(".form-login button[type=submit]")
        .btnLoader()
        .show();
      const errorObj = $(this).find(".login-error-message");
      const email = $(this)
        .find("input#email")
        .val();
      const password = $(this)
        .find("input#password")
        .val();
      errorObj.html("");
      errorObj.hide();

      api
        .processAgentLogin(email, password)
        .then(response => {
          api.REQUESTING_AGENT_LOGIN = false;
          $(".form-login button[type=submit]")
            .btnLoader()
            .hide();
          errorObj.html(response.message);
          errorObj.slideDown(200);
          window.location.href = response.redirect;
        })
        .catch(err => {
          $(".form-login button[type=submit]")
            .btnLoader()
            .hide();
          api.REQUESTING_AGENT_LOGIN = false;
          errorObj.html(err.responseJSON.message);
          errorObj.slideDown(200);
        });
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
